import { Tab, Tabs } from "@mui/material";
import useLocales from "src/hooks/useLocales";

type Props = {
	onChangeTab: (event: React.SyntheticEvent<Element, Event>, newValue: any) => void;
	currentTab: string;
};

export default function SettingsTab({ currentTab, onChangeTab }: Props) {
	const { translate } = useLocales();

	return (
		<Tabs
			allowScrollButtonsMobile
			onChange={onChangeTab}
			scrollButtons='auto'
			sx={{ mt: 2, mb: 2.5 }}
			textColor='primary'
			value={currentTab}
			variant='scrollable'
		>
			<Tab disableRipple label={translate("app_settings.app_details")} value='app_details' />
			<Tab disableRipple label={translate("app_settings.api_security")} value='api_security' />
			<Tab disableRipple label={translate("app_settings.api_client")} value='api_client' />
			<Tab disableRipple label={translate("app_settings.customization")} value='customization' />
			<Tab disableRipple label={translate("app_settings.configuration")} value='configuration' />
		</Tabs>
	);
}
